import React, { useEffect, useState } from "react";
import { Paper, Divider, Typography, IconButton, Tooltip } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from "@material-ui/core/styles";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import ActivityView from "../Activities/ActivityView";
import CreateActivities from "../Activities/CreateActivities";
import CreateAttachments from "../Activities/CreateAttachments";
import CreateNotes from "../Activities/CreateNotes";

const RelatedView = (props) => {
    //debugger;
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);
    const [isNoteOpen, setNoteOpen] = useState(false);
    const [rowsNote, setRowsNote] = useState([]);
    const [columnsNote, setColumnsNote] = useState([]);
    const [NoteID, setNoteID] = useState('');
    const [NoteCout, setNoteCout] = useState(0);
    const [ActivityCount, setActivityCount] = useState(0);
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    // const QutId = props.QuotationMainData[0].id == undefined ? "" : props.QuotationMainData[0].id;
    const openModal = (row) => {
        setNoteID(row);
        setNoteOpen(true);
    }

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} ><EditIcon fontSize="small" /></a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 50,
            },
            {
                field: 'NotesTitle',
                headerName: "Notes Title",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: 'Notes',
                headerName: "Notes",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
        ];
        setColumnsNote(gridCols);
    }, []);

    useEffect(() => {
        // debugger;
        if (props.QuotationNoteData !== undefined && props.QuotationNoteData.length > 0) {
            setRowsNote(props.QuotationNoteData);
            setNoteCout(props.QuotationNoteData.length);
        }
    }, [props.QuotationNoteData]);

    useEffect(() => {
        //console.log(ACID);
        setAccountID(props.ACID);
        setAccountName(props.ACName);
    }, [props.ACID]);

    return <div>
        <Paper style={{ marginTop: 7, height: 160 }} elevation={3}>
            <Typography className={classes.headerCmn} noWrap>
                Activities({ActivityCount})
                <div style={{ width: "100%" }}>
                    <div style={{ float: "right", marginTop: -12 }}>
                        <Tooltip title="Add Activity">
                            <IconButton onClick={() => { setOpen(true); }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </Typography>
            <Divider></Divider>
            <ActivityView
                ActivityType="Quotation"
                setActivityCount={setActivityCount}
                ActivityData={props.QuotationActivityData}
                RefDocumentID={props.QuotationID}
                PopulateData={props.PopulateData}
            />
        </Paper>
        <Paper style={{ height: 200 }} elevation={3}>
            <CreateAttachments
                RefDocumentID={props.QuotationID}
                Group="Quotation"
                QuotationAttachData={props.QuotationAttachData}
            />
        </Paper>
        <Paper style={{ height: 220 }} elevation={3}>
            <Typography className={classes.headerCmn} noWrap>
                Notes({NoteCout})
                <div style={{ width: "100%" }}>
                    <div style={{ float: "right", marginTop: -12 }}>
                        <Tooltip title="Add Note">
                            <IconButton onClick={() => { setNoteOpen(true); setNoteID(''); }}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </Typography>
            <Divider></Divider>
            <div>
                <BiztranControls.DataGrid
                    rowHeight={20}
                    headerHeight={20}
                    rows={rowsNote}
                    columns={columnsNote}
                    checkboxSelection={false}
                    hideFooterPagination={true}
                    hideFooter={true}
                    Height="180px"
                    //Height="250px"
                    Width="100%"
                />
            </div>
        </Paper>
        <ModalFrame
            title="Activity Details"
            maxWidth="md"
            isOpen={isOpen}
            setOpen={setOpen}
        >
            <CreateActivities
                ActivityType="Quotation"
                setOpen={setOpen}
                RefDocumentID={props.QuotationID}
                DisableUpdate={false}
                DisableComplete={false}
                DisableDelete={true}
                PopulateData={props.PopulateData}
                DisableLink="none"
                pageName={"Activities"}
                AccountID={AccountID}
                AccountName={AccountName}
                DisableCustomer={true}
                DisableContact={false}
                DisableRefDoc={true}
            />
        </ModalFrame>
        <ModalFrame
            title="Note Details"
            maxWidth="xs"
            isOpen={isNoteOpen}
            setOpen={setNoteOpen}
        >
            <CreateNotes
                setNoteOpen={setNoteOpen}
                RefDocumentID={props.QuotationID}
                pageName={"Notes"}
                NoteID={NoteID}
                QuotationNoteData={props.QuotationNoteData}
                PopulateData={props.PopulateData}
            />
        </ModalFrame>
    </div>
};

const useStyles = makeStyles((theme) => ({
    headerCmn: {
        height: "1.6rem",
        fontSize: "1rem",
        display: "flex",
        flexDirection: "row",
        margin: "0.3rem",
        fontWeight: "bold",
    },
}));

export default RelatedView;
